<!--
 * @Author: AnNa
 * @Date: 2021-08-09 11:29:15
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-09 18:37:04
 * @Description: 
-->
<template>
  <a-popover title="评论模板" trigger="click">
    <a-button ref="btn" icon="message" size="small" :style="{ marginRight: '5px' }" shape="circle" />
    <div :style="{ width: '300px', height: '350px', overflowY: 'auto' }" slot="content">
      <a-list
        :data-source="list"
        :locale="{
          emptyText: '快去添加模板吧~'
        }"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          {{ item.comment_text }}
          <br />
          <a @click="ok(item.comment_text)">立即使用</a>
          <a style="padding-left: 10px" @click="copy(item.comment_text)">复制</a>
        </a-list-item>
        <!-- <div slot="header">
          Header
        </div>
        <div slot="footer">
          Footer
        </div> -->
      </a-list>
      <router-link :to="{ name: 'pyqMessage' }">
        <a-button type="dashed" block>添加模板</a-button>
      </router-link>
    </div>
  </a-popover>
</template>
<script>
import { queryListOfMessage } from '@/api/pyq'

export default {
  data() {
    return {
      list: []
    }
  },
  created() {
    queryListOfMessage({
      pageSize: 2000
    }).then(res => {
      // console.log(res.data)
      this.list = res.data
    })
  },
  methods: {
    ok(text) {
      this.$emit('append', text)
    },
    copy(text) {
      this.$copyText(text)
      this.$message.success('复制成功！')
      this.$refs.btn.$el.click()
    }
  }
}
</script>
